import PropTypes from 'prop-types'
import React from 'react'
import styles from './_field.css'
import classnames from 'classnames'

const propTypes = {
  labelComponent: PropTypes.node,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  bold: PropTypes.bool,
}

export function FieldLabel ({ labelComponent, required, disabled, bold }) {
  return (labelComponent ?
    <div className={classnames(styles.label, {
      [styles.bold]: bold,
    })}>
      {labelComponent}
      {required && !disabled && <b className={styles.required}>{'*'}</b>}
    </div>
  : null)
}

FieldLabel.propTypes = propTypes

export default FieldLabel



// WEBPACK FOOTER //
// ./src/components/forms/FieldLabel.jsx